module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousEx
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Cargo Tracking")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.airFreightModel.allModuleId ? this.airFreightModel.allModuleId : '',
      "jobSeriesBanner": this.airFreightModel.airFFExportSeries ? this.airFreightModel.airFFExportSeries : '',
      "bannerClientName": this.getCLientData[0].clientName ? this.getCLientData[0].clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Assignment No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "assignmentNumber",
      "id": "assignmentNumber",
      "disabled": ""
    },
    model: {
      value: (_vm.BookingShippingLine.assignmentNumber),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "assignmentNumber", $$v)
      },
      expression: "BookingShippingLine.assignmentNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("MAWBL No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "MAWBNumber",
      "id": "MAWBNumber",
      "disabled": ""
    },
    model: {
      value: (_vm.BookingShippingLine.MAWBNumber),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "MAWBNumber", $$v)
      },
      expression: "BookingShippingLine.MAWBNumber"
    }
  })], 1), _vm._v(" "), (!_vm.BookingShippingLine.MAWBNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.MAWBNumber))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.tentativeDetailArrayList.length <= 0) ? _c('div', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Flight Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "flightNumber",
      "id": "flightNumber"
    },
    model: {
      value: (_vm.BookingShippingLine.flightNumber),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "flightNumber", $$v)
      },
      expression: "BookingShippingLine.flightNumber"
    }
  })], 1), _vm._v(" "), (!_vm.BookingShippingLine.flightNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.flightNumber))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("From AirPort")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "list": _vm.portList,
      "placeholder": "Select Port Name"
    },
    model: {
      value: (_vm.BookingShippingLine.fromAirport),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "fromAirport", $$v)
      },
      expression: "BookingShippingLine.fromAirport"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.fromAirport) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.fromAirport))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("To AirPort")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "list": _vm.portList,
      "placeholder": "Select Port Name"
    },
    model: {
      value: (_vm.BookingShippingLine.toAirport),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "toAirport", $$v)
      },
      expression: "BookingShippingLine.toAirport"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.toAirport) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.toAirport))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Expected Departure Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "dateDeparture",
      "name": "dateDeparture"
    },
    model: {
      value: (_vm.BookingShippingLine.dateDeparture),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "dateDeparture", $$v)
      },
      expression: "BookingShippingLine.dateDeparture"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.dateDeparture) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.dateDeparture))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Expected Arrival Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "dateArrival",
      "name": "dateArrival"
    },
    model: {
      value: (_vm.BookingShippingLine.dateArrival),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "dateArrival", $$v)
      },
      expression: "BookingShippingLine.dateArrival"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.dateArrival) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBookingShippingLine.dateArrival))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Actual Departure Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "actualDateDeparture",
      "name": "actualDateDeparture"
    },
    model: {
      value: (_vm.BookingShippingLine.actualDateDeparture),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "actualDateDeparture", $$v)
      },
      expression: "BookingShippingLine.actualDateDeparture"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Actual Arrival Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "actualDateArrival",
      "name": "actualDateArrival"
    },
    model: {
      value: (_vm.BookingShippingLine.actualDateArrival),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "actualDateArrival", $$v)
      },
      expression: "BookingShippingLine.actualDateArrival"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tentativeDetailArrayList.length > 0) ? _c('div', [(_vm.showAddAirport == true) ? _c('div', [_c('b-card', {
    staticClass: "gutr",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Flight Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "name": "flightNumber",
      "id": "flightNumber"
    },
    model: {
      value: (_vm.moreAirportModel.flightNumber),
      callback: function($$v) {
        _vm.$set(_vm.moreAirportModel, "flightNumber", $$v)
      },
      expression: "moreAirportModel.flightNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("From AirPort")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "list": _vm.locationMultiTrans,
      "placeholder": "Select Port Name"
    },
    model: {
      value: (_vm.moreAirportModel.fromAirport),
      callback: function($$v) {
        _vm.$set(_vm.moreAirportModel, "fromAirport", $$v)
      },
      expression: "moreAirportModel.fromAirport"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("To AirPort")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "list": _vm.locationMultiTrans,
      "placeholder": "Select Port Name"
    },
    model: {
      value: (_vm.moreAirportModel.toAirport),
      callback: function($$v) {
        _vm.$set(_vm.moreAirportModel, "toAirport", $$v)
      },
      expression: "moreAirportModel.toAirport"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Expected Departure Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "disabled": "",
      "lang": "en",
      "id": "dateDeparture",
      "name": "dateDeparture"
    },
    model: {
      value: (_vm.moreAirportModel.dateDeparture),
      callback: function($$v) {
        _vm.$set(_vm.moreAirportModel, "dateDeparture", $$v)
      },
      expression: "moreAirportModel.dateDeparture"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Expected Arrival Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "disabled": "",
      "lang": "en",
      "id": "dateArrival",
      "name": "dateArrival"
    },
    model: {
      value: (_vm.moreAirportModel.dateArrival),
      callback: function($$v) {
        _vm.$set(_vm.moreAirportModel, "dateArrival", $$v)
      },
      expression: "moreAirportModel.dateArrival"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Actual Departure Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "actualDateDeparture",
      "name": "actualDateDeparture"
    },
    model: {
      value: (_vm.moreAirportModel.actualDateDeparture),
      callback: function($$v) {
        _vm.$set(_vm.moreAirportModel, "actualDateDeparture", $$v)
      },
      expression: "moreAirportModel.actualDateDeparture"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Actual Arrival Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "actualDateArrival",
      "name": "actualDateArrival"
    },
    model: {
      value: (_vm.moreAirportModel.actualDateArrival),
      callback: function($$v) {
        _vm.$set(_vm.moreAirportModel, "actualDateArrival", $$v)
      },
      expression: "moreAirportModel.actualDateArrival"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "size": "sm",
      "variant": "info",
      "id": "addButtonLoader11"
    },
    on: {
      "click": _vm.addAirport
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader11"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tentativeDetailArrayList.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('b-badge', [_vm._v(" Transhipment Details")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered ",
    attrs: {
      "id": "ffBookingTentative"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Flight No.")]), _vm._v(" "), _c('th', [_vm._v("From Airport")]), _vm._v(" "), _c('th', [_vm._v("To Airport")]), _vm._v(" "), _c('th', [_vm._v("Arrival & Departure Details")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tentativeDetailArrayList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.flightNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.fromAirportName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.toAirportName))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Expected Departure Date:")]), _vm._v("\n                      " + _vm._s(item.dateDeparture) + "\n                      "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Actual Departure Date:")]), _vm._v("\n                      " + _vm._s(item.actualDateDeparture == null ? 'Peding' : item.actualDateDeparture) + "\n                      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Expected Arrival Date :")]), _vm._v("\n                      " + _vm._s(item.dateArrival) + "\n                      "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Actual Arrival Date :")]), _vm._v("\n                      " + _vm._s(item.actualDateArrival == null ? 'Pending' : item.actualDateArrival) + "\n                    ")]), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-dark"
      },
      on: {
        "click": function($event) {
          _vm.viewEdit(item, index)
        }
      }
    }, [_vm._v("\n                        Edit\n                      ")])], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [(_vm.showAddAirport == false) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.addTracking
    }
  }, [_vm._v("Save & Submit")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopAddTracking",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAddTracking
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-092a7259","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/airFreight/airTrackingFFExport.vue
// module id = 2377
// module chunks = 0